class FaqAccordion extends HTMLElement {
    constructor() {
        super();
        this.allDetails = this.querySelectorAll('details');
        this.setupAccordion();
    }

    setupAccordion() {
        this.allDetails.forEach((targetDetail) => {
            targetDetail.addEventListener('click', (event) => {
                // Prevent default behavior if clicking on summary
                if (event.target.tagName === 'SUMMARY' || event.target.closest('summary')) {
                    event.preventDefault();

                    // If this detail is already open, close it
                    if (targetDetail.hasAttribute('open')) {
                        this.closeDetail(targetDetail);
                    } else {
                        // Close all other details
                        this.allDetails.forEach((detail) => {
                            if (detail !== targetDetail && detail.hasAttribute('open')) {
                                this.closeDetail(detail);
                            }
                        });

                        // Open the clicked detail
                        this.openDetail(targetDetail);
                    }
                }
            });
        });
    }

    openDetail(detail) {
        detail.setAttribute('open', '');
        const summary = detail.querySelector('summary');
        if (summary) {
            summary.setAttribute('aria-expanded', 'true');
        }
    }

    closeDetail(detail) {
        detail.removeAttribute('open');
        const summary = detail.querySelector('summary');
        if (summary) {
            summary.setAttribute('aria-expanded', 'false');
        }
    }
}

customElements.define('faq-accordion', FaqAccordion);
